import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { CategoriaService } from '../../categoria/categoria.service';
import { ProductoService } from '../producto.service';

@Component({
  selector: 'app-producto-update',
  templateUrl: './producto-update.component.html',
  styleUrls: ['./producto-update.component.scss']
})
export class ProductoUpdateComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  estado_seleccionado!: number
  moneda_seleccionada!: number
  categoria_seleccionada!: number
  @Input() element: any = {}
  categorias: Array<any> = []
  estado = [{ id: 1, name: 'Activo' }, { id: -1, name: 'Inactivo' }]
  moneda = [{ id: 1, name: 'CLP' }, { id: 2, name: 'USD' }, { id: 3, name: 'UF' }]
  constructor(
    public formBuilder: FormBuilder,
    public config: ConfigService,
    public formatter: FormatterService,
    private loading: LoadingService,
    private alerts: AlertService,
    public service: ProductoService,
    public _service: CategoriaService,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.select();
    this.form = this.formBuilder.group({
      id:['', [Validators.required]],
      nombre: ['', [Validators.required]],
      descripcion: [],
      sku: [],
      codigo_barra: [],
      precio_venta: ['', [Validators.required]],
      precio_compra: ['', [Validators.required]],
      precio_mayorista: [],
      moneda: ['', Validators.required],
      stock_minimo: [],
      estado: ['', Validators.required],
      categoria_id: [],
      empresa_id: ['', [Validators.required]],
    });
    this.categoria_seleccionada = this.element.categoria_id;
    this.estado_seleccionado = this.element.estado;
    this.moneda_seleccionada = this.element.moneda;
    this.form.patchValue(this.element);
  }

  guardar(): void {
    if (this.form.valid) {
      this.loading.show();
      this.service.update(this.form.value).subscribe({
        next: (res) => {
          this.loading.hide();
          this.activeModal.close(res.model);
          this.alerts.addAlert(res.response, "success");
        }, 
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se pudo guardar el registro", "danger");
          if (err.error.response) {
            this.alerts.addAlert(err.error.response, "danger");
          }
        }
      });
    } else {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
    }
  }

  select(): void {
    this.loading.show()
    let user = JSON.parse(localStorage.getItem('usuario') as string);
    this._service.select(user).subscribe({
      next: (res) => {
        this.loading.hide();
        this.categorias = res
      }, error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo Cargar Tipos de gastos de la empresa", "danger");
        if (err.error.response) {
          this.alerts.addAlert(err.error.response, "danger");
        }
      }
    });
  }
}
